import React from "react";
import Button from "../../../components/Button";
import InstantRatesImg from "../../../assets/images/Instant_rates.svg";
import Homepage_Data from "../../../utils/HomepageData";
import { FaCircle } from "react-icons/fa6";

export default function InstantRates() {
  return (
    <div className="mx-5 sm:mx-6 md:mx-8 lg:mx-auto lg:max-w-10xl lg:mx-[50px] mt-8 sm:mt-12 md:mt-16 lg:py-10 lg:px-12 sm:flex sm:bg-[#7B3BCC1A]">
      {/* Text Content */}
      <div className="sm:w-[60%] lg:w-[55%] xl:w-[50%]">
        {/* Title */}
        <h2 className="font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[40px] text-[#2C2C2C]">
          {Homepage_Data.instantRate.heading}
        </h2>

        {/* Description */}
        <p className="font-semibold text-sm sm:text-base md:text-lg lg:text-[20px] xl:text-[20px] text-[#888888] mt-4 sm:mt-5 md:mt-6 lg:mt-8">
          {Homepage_Data.instantRate.desc}
        </p>

        <div>
          <p className="font-semibold text-sm sm:text-base md:text-lg lg:text-[20px] xl:text-[20px] text-[#888888] my-2 sm:my-3 md:my-2 lg:my-3">
            {Homepage_Data.instantRate.key_advantages.title}
          </p>

          <div className="flex flex-col gap-2 font-semibold text-[#888888]">
            {Homepage_Data.instantRate.key_advantages.bullets?.map((item) => (
              <div className="flex">
                <FaCircle className="text-[14px] mt-1 mr-2" /> <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
        <div>
          <p className="font-semibold text-sm sm:text-base md:text-lg lg:text-[20px] xl:text-[20px] text-[#888888] my-2 sm:my-3 md:my-2 lg:my-3">
            {Homepage_Data.instantRate.ideal_for.title}
          </p>

          <div className="flex flex-col gap-2 font-semibold text-[#888888]">
            {Homepage_Data.instantRate.ideal_for.bullets?.map((item) => (
              <div className="flex">
                <FaCircle className="text-[14px] mt-1 mr-2" /> <p>{item}</p>
              </div>
            ))}
          </div>
          <div className="text-[#888888]">
            <p className="font-semibold text-sm sm:text-base md:text-lg lg:text-[20px] xl:text-[20px] text-[#888888] mt-4 sm:mt-5 md:mt-6 lg:mt-8">
              {Homepage_Data.instantRate.experience_difference.title}
            </p>
            <p className=" font-semibold text-sm sm:text-base md:text-md lg:text-[16px] xl:text-[18px]">
              {Homepage_Data.instantRate.experience_difference.desc}
            </p>
          </div>
        </div>
        {/* Button (Desktop) */}
        {/* <Button
          btnText="Sign Up for an Account"
          classes="bg-[#7B3BCC] hidden sm:inline-block w-full sm:w-fit sm:px-8 sm:py-4 mt-5 sm:mt-6 md:mt-4 text-sm sm:text-base md:text-lg lg:text-[16px] text-white font-bold hover:bg-[#6a30b5] transition-colors duration-300"
        /> */}
      </div>

      {/* Image Section */}
      <div className="sm:w-[40%] lg:w-[45%] xl:w-[50%] mt-6 sm:mt-0">
        <img
          src={InstantRatesImg}
          alt="Instant-Rates-Illustration"
          className="w-full h-auto md:max-w-[90%] md:mx-auto lg:max-w-full"
        />

        {/* Button (Mobile) */}
        {/* <Button
          btnText="Sign Up for an Account"
          classes="bg-[#7B3BCC] sm:hidden w-full mt-6 text-sm text-white font-bold py-3 hover:bg-[#6a30b5] transition-colors duration-300"
        /> */}
      </div>
    </div>
  );
}
